import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {},

  container: {
    padding: '30px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      padding: '30px 50px',
    },

    [theme.breakpoints.up('md')]: {
      padding: '30px 50px 50px',
      flexDirection: 'row',
      columnGap: '50px',
    },

    [theme.breakpoints.up('lg')]: {
      columnGap: '100px',
    },
  },

  imgWrapper: {
    flexShrink: 0,
    position: 'relative',
  },

  textWrapper: {
    maxWidth: '650px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  },

  type: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '50px',
      marginTop: '30px',
    },
  },

  dishNameAndSpiceWrapper: {
    margin: '5px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '10px',

    [theme.breakpoints.up('md')]: {
      margin: '20px 0 5px',
      flexDirection: 'row',
      columnGap: '20px',
    },
  },

  byWhomPublished: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: '20px',
  },

  list: {
    '&::marker': {
      color: theme.palette.garamMasala.main,
    },
  },

  bottomContainer: {
    padding: '15px 25px',
    [theme.breakpoints.up('sm')]: {
      padding: '15px 50px',
    },
  },

  backToCatalogWrapper: {
    cursor: 'pointer',
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    columnGap: '20px',
  },
});
